const femaleCricketTeam =  [{
    "id": 1,
    "name": "Salma Khatun",
    "salary": 30000,
    "team_name": "Transition Granular E-Tailers",
    "role": "Allrounder",
    "image": "https://p.imgci.com/db/PICTURES/CMS/305300/305377.png"
  }, {
    "id": 2,
    "name": "Fahima Khatun",
    "salary": 40000,
    "team_name": "Iterate One-to-One Bandwidth",
    "role": "Bowler",
    "image": "https://p.imgci.com/db/PICTURES/CMS/305300/305365.png"
  }, {
    "id": 3,
    "name": "Ritu Moni",
    "salary": 50000,
    "team_name": "Optimize Extensible Content",
    "role": "Batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225029.html"
  }, {
    "id": 4,
    "name": "Rumana Ahmed",
    "salary": 25000,
    "team_name": "Productize Wireless Initiatives",
    "role": "Allrounder",
    "image": "https://www.espncricinfo.com/inline/content/image/1225030.html"
  }, {
    "id": 5,
    "name": "Fargana Hoque",
    "salary": 15000,
    "team_name": "Reinvent Scalable Mindshare",
    "role": "Top-order batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225018.html"
  }, {
    "id": 6,
    "name": "Nigar Sultana",
    "salary": 35000,
    "team_name": "Implement Next-Generation Sers",
    "role": "Wicketkeeper batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225026.html"
  }, {
    "id": 7,
    "name": "Sanjida Islam",
    "salary": 30000,
    "team_name": "Evolve Plug-and-Play Eyeballs",
    "role": "Top-order batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225032.html"
  }, {
    "id": 8,
    "name": "Ayasha Rahman",
    "salary": 20000,
    "team_name": "Innovate Leading-Edge E-Commerce",
    "role": "Opening batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225016.html"
  }, {
    "id": 9,
    "name": "Murshida Khatun",
    "salary": 15000,
    "team_name": "Engage Rich Deliverables",
    "role": "Batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225023.html"
  }, {
    "id": 10,
    "name": "Panna Ghosh",
    "salary": 10000,
    "team_name": "Transition Holistic Platforms",
    "role": "Batsman",
    "image": "https://www.espncricinfo.com/inline/content/image/1225028.html"
  }]
  export default femaleCricketTeam;